var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0.5C1.23478 0.5 0.98043 0.605357 0.792893 0.792893C0.605357 0.98043 0.5 1.23478 0.5 1.5C0.5 1.76522 0.605357 2.01957 0.792893 2.20711C0.98043 2.39464 1.23478 2.5 1.5 2.5H18.5C18.7652 2.5 19.0196 2.39464 19.2071 2.20711C19.3946 2.01957 19.5 1.76522 19.5 1.5C19.5 1.23478 19.3946 0.98043 19.2071 0.792893C19.0196 0.605357 18.7652 0.5 18.5 0.5H1.5ZM0.5 7.5C0.5 7.23478 0.605357 6.98043 0.792893 6.79289C0.98043 6.60536 1.23478 6.5 1.5 6.5H18.5C18.7652 6.5 19.0196 6.60536 19.2071 6.79289C19.3946 6.98043 19.5 7.23478 19.5 7.5C19.5 7.76522 19.3946 8.01957 19.2071 8.20711C19.0196 8.39464 18.7652 8.5 18.5 8.5H1.5C1.23478 8.5 0.98043 8.39464 0.792893 8.20711C0.605357 8.01957 0.5 7.76522 0.5 7.5ZM0.5 13.501C0.5 13.2358 0.605357 12.9814 0.792893 12.7939C0.98043 12.6064 1.23478 12.501 1.5 12.501H18.5C18.7652 12.501 19.0196 12.6064 19.2071 12.7939C19.3946 12.9814 19.5 13.2358 19.5 13.501C19.5 13.7662 19.3946 14.0206 19.2071 14.2081C19.0196 14.3956 18.7652 14.501 18.5 14.501H1.5C1.23478 14.501 0.98043 14.3956 0.792893 14.2081C0.605357 14.0206 0.5 13.7662 0.5 13.501Z",
    fill: "#4237CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burgerMenu.78e5591a925b53339b3a7e56813acc8d.svg";
export { ForwardRef as ReactComponent };